<template>

    <form v-if="sent === false" role="form" method="POST" @submit.prevent="send()" novalidate @keydown="errors.remove('generic')">
        <div class="content">
            <label>
                <input type="email" v-model="form.email" name="email" v-validate="'required|email'" placeholder="E-pasts"/>
                <span class="form-error is-visible" v-if="errors.has('email')">{{ errors.first('email') }}</span>
            </label>

            <span class="form-error is-visible" v-if="errors.has('generic')">{{ errors.first('generic') }}</span>

            <div class="text-center">
                <button class="large primary button" type="submit" value="Sūtīt" :disabled="errors.any()">Sūtīt</button>
            </div>
        </div>
    </form>

    <p v-else="">Saite ir nosūtīta. Seko instrukcijām e-pastā, lai atjaunotu savu paroli.</p>

</template>

<script>
    import { Form } from '../../modules/forms/Form'
    import auth from '../../api/auth.js'

    export default {
        name: 'email-form',

        data() {
            return {
                form: new Form({
                    email: ''
                }),

                sent: false
            }
        },

        methods: {
            send() {
                this.$validator.validateAll()
                    .then(result => {
                        if (!result) return;

                        auth.email(this.form.data())
                            .then(response => {
                                this.sent = true
                            }, response => {
                                const errors = response.data.errors;
                                // Record errors for available fields only
                                for (let field in errors) {
                                    if (!errors.hasOwnProperty(field)) continue;

                                    if (this.form.hasOwnProperty(field)) {
                                        this.errors.add(field, errors[field][0], 'auth')
                                    }
                                }
                            })
                            .catch(error => {

                                this.setErrors(error.response.data);

                                //Record form wide error
                                if (errors.hasOwnProperty('error') && errors.hasOwnProperty('message')) {
                                    this.errors.add('generic', errors.message, 'auth')
                                }

                                // Record errors for available fields only
                                for (let field in errors) {
                                    if (!errors.hasOwnProperty(field)) continue;

                                    if (this.form.hasOwnProperty(field)) {
                                        this.errors.add(field, errors[field], 'auth')
                                    }
                                }
                            })
                    })
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/auth/EmailForm.vue